import React, { type ComponentType, type PropsWithChildren } from 'react';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react/component-with-fg';

import { useOptions } from '../../controllers/options-provider';
import { useLocalSideNavUserData } from '../../controllers/user-state/persistence/use-local-side-nav-user-data';
import { useSplitLocalSideNavUserData } from '../../controllers/user-state/persistence/use-local-side-nav-user-data/use-split-local-side-nav-user-data';
import { StoreProviders } from '../../controllers/user-state/store-providers';

export const LocalStore: ComponentType<PropsWithChildren> = componentWithFG(
	'navx-5493-gsn-local-storage-alignment',
	LocalStoreNEW,
	LocalStoreOLD,
);

function LocalStoreNEW({ children }: PropsWithChildren): React.JSX.Element {
	const { app } = useOptions();
	const userStoreProps = useSplitLocalSideNavUserData({ app });

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}

function LocalStoreOLD({ children }: PropsWithChildren): React.JSX.Element {
	const { app } = useOptions();

	// This is user data for the menu and the sidebar
	const userStoreProps = useLocalSideNavUserData({ app });

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
